import { EnableToSend} from "./models/enabletosend.model";
import { Injectable } from "@angular/core";

@Injectable()
export class EnableToSendService{
  constructor(){
    
  }
  getListEnableToSend():EnableToSend[]{
    let enableToSendList:EnableToSend[]=[];
    enableToSendList.push( new EnableToSend(1, 'Có send'));
    enableToSendList.push( new EnableToSend(0, 'Không send'));
    return enableToSendList;
  }
}